import getIn from 'transmute/getIn';
// @ts-expect-error ts-migrate(2322) FIXME: Type 'Curry1<unknown, unknown>' is not assignable ... Remove this comment to see the full error message
export const getZeroState = getIn(['zeroState', 'data']);